import Api from "@/services/api";
import {
    Background, BackgroundInfo, BackgroundsFilterDtoIn
} from "@/services/backgrounds/types";

export async function getAllBackgrounds(): Promise<Array<Background>> {
    return new Promise((resolve, reject) => {
        Api.get("/background").then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getBackground(id: string): Promise<Background> {
    return new Promise((resolve, reject) => {
        Api.get(`/background/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function createBackground(model: Background): Promise<string> {
    return new Promise((resolve, reject) => {
        Api.post("/background", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function updateBackground(model: Background): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.put("/background", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function deleteBackground(id: string): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.delete(`/background/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function checkDelete(id: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
        Api.get(`/background/delete/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function GetBackgroundInfo(id: string): Promise<BackgroundInfo> {
    return new Promise((resolve, reject) => {
        Api.get(`/background/info/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getFilteredBackgrounds(model: BackgroundsFilterDtoIn): Promise<Background[]> {
    return new Promise((resolve, reject) => {
        Api.post("/background/filter", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export function copyBackground(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
        Api.post(`/background/copy/${id}`, null).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}
